import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { LegTransportType } from '@trainline-shareable/journey-live-tracker';
import LegBikeReservations from '@trainline-shareable/journey-live-tracker/lib/types/LegBikeReservations';
import LocalAreaTransportAddons from '@trainline-shareable/journey-live-tracker/lib/types/LocalAreaTransportAddons';
import SeatReservation from '@trainline-shareable/journey-live-tracker/lib/types/SeatReservation';
import LegExtras from '@trainline-shareable/journey-live-tracker/lib/types/LegExtras';

import request from '@contactcentre-web/utils/request';

import journey, { inboundJourney } from '../components/Journey/mock/journey';

type OriginDestination = {
  id: string;
  code: string;
  name: string;
};

type JourneyLeg = {
  id: string;
  localArriveAt: string;
  localDepartAt: string;
  origin: OriginDestination;
  destination: OriginDestination;
  carrierName: string;
  carrierUrn: string;
  timetableId?: string | null;
  transportModeName: LegTransportType;
  legNumber: number;
  bikeReservations?: LegBikeReservations[];
  extras?: LegExtras[];
  seatReservations?: SeatReservation[];
  totalLegs: number;
  localAreaTransportAddons?: LocalAreaTransportAddons;
  onboardServices?: string[];
};

export type Journey = {
  origin: string;
  destination: string;
  duration: string;
  departAt: string;
  arriveAt: string;
  legs: JourneyLeg[];
  splitTicketType?: string;
  direction: string;
  id: string;
};
export interface Itinerary {
  itinerariesCount: number;
  itinerary: {
    id: string;
    origin: string;
    destination: string;
    departAt: string;
    arriveAt: string;
    index: number;
    outwardJourney: Journey;
    inwardJourney: Journey;
  };
}
export const useItineraryViews = (orderId: string) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (loading) {
      setTimeout(() => setLoading(false), 800);
    }
  });
  useQuery(['itineraryViews', orderId], () =>
    request<Itinerary>(`/api/itineraryViews/${orderId}?itineraryIndex=0`, undefined, false)
  );
  return {
    loading,
    itinerary: {
      id: '123',
      origin: 'Hayes & Harlington',
      destination: 'Tottenham Court Road (Elizabeth line)',
      departAt: '2025-06-04T16:12:00+01:00',
      arriveAt: '2025-06-04T16:38:00+01:00',
      index: 1,
      outwardJourney: journey,
      inboundJourney: inboundJourney,
    },
    itinerariesCount: 1,
  };
};
